module.exports = "<p>\r\n  heatmap-help works!\r\n</p>\r\n"